// Path prefixes reachable without an authenticated session. Shared by the
// client-side auth guard (useAuthGuard) and the edge middleware (proxy.ts) so
// the two enforcement layers can't drift. Zero runtime deps on purpose — safe
// to import in both the edge and client bundles.
//
// /mcp-auth: the MCP Gateway redirects the browser here mid-OAuth-flow, before
// a console session exists. /self-registration: the existing IHG-demo carve-out.
export const PUBLIC_PATH_PREFIXES = ['/self-registration', '/mcp-auth'] as const;
